import React from 'react'
import { Electric } from './interface/Electric'
import { HomeCategory } from '../../../../types/homeCategoryType';
import { useAppDispatch } from '../../../../State/Store';
import { getProductsByCategoryId } from '../../../../State/customer/ProductSlice';
import { useNavigate } from 'react-router-dom';
interface ElectricCategoryCardProps {
  item:HomeCategory; // Expecting an object with `name` and `image` properties
}
export const ElectricCategoryCard:React.FC<ElectricCategoryCardProps> = ({item}) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const handleClick =async (categoryId:string,pageNumber:number) => { 
  await  dispatch(getProductsByCategoryId({categoryId,pageNumber})).unwrap()
  navigate(`/products/${categoryId}?page=${pageNumber}`)
   }
  console.log("item.name: ",item.categoryId);
  return (
    <button  onClick={() => {item.categoryId!=undefined && handleClick(item.categoryId,0) }} className='flex flex-col gap-2 justify-center'>
        <img className='object-contain h-12' src={item.image} alt="not found" />
        <h2 className='font-semibold text-sm text-center cursor-pointer'>{item.name}</h2>
    </button>
  )
}
